/**
 * Login discovery methods returned by `/sso/discover` and held in
 * `auth.discoverState.method`. SSO redirects the user to their IdP; PASSWORD
 * shows the password step (and is also the fallback when discovery fails).
 */
export const DISCOVER_METHOD = {
  SSO: 'SSO',
  PASSWORD: 'PASSWORD',
};

Object.freeze(DISCOVER_METHOD);
